import { Button } from '@nesso/ui/primitives/button';
import { DropdownMenuItem, DropdownMenuShortcut } from '@nesso/ui/primitives/dropdown-menu';

const footerLinks = [
    {
        label: 'Privacy',
        url: 'https://www.nessoapp.com/privacy',
    },
    {
        label: 'Terms',
        url: 'https://www.nessoapp.com/terms',
    },
] as const;

export function UserDropdownFooterLinks() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="flex items-center justify-center gap-1 py-3 px-2">
            {footerLinks.map((link) => (
                <DropdownMenuItem
                    asChild
                    key={link.label}
                    onPointerMove={(e) => e.preventDefault()}
                    onPointerLeave={(e) => e.preventDefault()}
                    className="focus-visible:bg-transparent hover:bg-transparent"
                >
                    <Button
                        variant="link"
                        className="h-auto px-1 py-0 text-xs leading-3"
                        onClick={() => window.open(link.url, '_blank')}
                    >
                        {link.label}
                    </Button>
                </DropdownMenuItem>
            ))}
            <DropdownMenuShortcut className="text-xs font-medium text-muted-foreground/85 leading-3">
                © {currentYear} Nesso Labs, Inc
            </DropdownMenuShortcut>
        </div>
    );
}
